import { loginSP } from "../../services/rest/servicesProvider/servicesProvider";
import { getPayload } from "../../utils/openPayloadToken";
import validateLoginSpecialist from "./validateLoginSpecialist";

export const sendDataSpecialist = async ({ formValues, setErrors }) => {
  try {
    const validationErrors = validateLoginSpecialist(formValues);
    if (Object.keys(validationErrors).length !== 0) {
      setErrors(validationErrors);
      return { userData: undefined };
    }
    const { token2, refreshToken } = await loginSP(formValues);
    const userData = getPayload(token2);
    return { userData, refreshToken };
  } catch (error) {
    throw error;
  }
};

export const filterMembreships = (memberships, membershipUser) => {
  let userMembership = {};

  memberships.map((membership) => {
    if (membership?.planName === membershipUser) {
      userMembership = { ...membership };
    }
  });
  return { userMembership };
};
